// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__pVQIX","loader":"Loader_loader__Iuf6t","mulShdSpin":"Loader_mulShdSpin__wVHBi"};